import { writable } from 'svelte/store';

/**
 * samlla#0xhq (a): set when a 401 repeats inside the login-redirect window —
 * the app shows a neutral "we couldn't confirm your session" state instead of
 * redirecting again. Never set on network errors or 5xx.
 */
export const sessionUnconfirmed = writable(false);
